/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Custom libraries
import { REG_EX, SLASH, EMPTY_STRING, CS } from "../constants/common";

const asArray = (obj: any) => (Array.isArray(obj) ? obj : [obj]);

const storeUtil = {
  isNumeric: (input: string) => {
    const NUMERIC = REG_EX.NUMERIC;
    return NUMERIC.test(input);
  },
  getParentCategoryId: (parentCatalogGroupID: any): string => {
    let categoryIdentifier: string = EMPTY_STRING;
    if (parentCatalogGroupID) {
      let ids: string[] = [];
      if (
        Array.isArray(parentCatalogGroupID) &&
        parentCatalogGroupID.length > 0
      ) {
        ids = parentCatalogGroupID[0].split(SLASH);
      } else {
        ids = parentCatalogGroupID?.split(SLASH);
      }
      if (ids && ids.length > 0) {
        categoryIdentifier = ids[ids.length - 1];
      }
    }
    return categoryIdentifier;
  },
  toMap: (a, k?) => {
    return a.reduce((m, v) => {
      m[k ? v[k] : v] = v;
      return m;
    }, {});
  },
  csValue: (obj) => asArray(obj).join(CS),
};

export default storeUtil;
